module.exports = __webpack_public_path__ + "mobile/img/img_bg_checkin.fe1ea4a1.jpg";